import {useState} from "react";
import PropTypes from "prop-types";
import RandomLotteryComponent from "../../Components/lottery/random/RandomLotteryComponent";
import {useLotteryDraw} from "../../Components/lottery/hooks/useLotteryDraw";
import DrawLoadingScreen from "../../Components/lottery/draw/DrawLoadingScreen";
import WinnersPanel from "../../Components/lottery/draw/WinnersPanel";
import WinnerModal from "../../Components/lottery/draw/WinnerModal";
import FinalResultsModal from "../../Components/lottery/draw/FinalResultsModal";
import {CAMPAIGN} from "../../config/campaign";
import {getActivePhase} from "../../config/campaignPhases";
import "./HappyPayLottery.css";

// Props remain as overrides; left unset, everything comes from the active phase
// in config/campaign.js so there is one place to edit per campaign.
const HappyPayLottery = ({maxMaleWinners, maxFemaleWinners, name}) => {
    // Which draw is this? The phase whose window contains today, else the most
    // recent — the same rule the backend uses to choose an iteration.
    const phase = getActivePhase();

    const maleQuota = maxMaleWinners ?? phase?.winners.male ?? 0;
    const femaleQuota = maxFemaleWinners ?? phase?.winners.female ?? 0;
    const heading = name ?? phase?.name ?? 'Урамшуулал';

    const {
        loading, refreshing, refresh,
        allLotteries, currentTrack, meritWinner, winners, maxWinners, isComplete,
        isSaving, currentWinner, isWinnerModalOpen, isFinalModalOpen,
        openFinalModal, closeFinalModal, selectWinner, confirmWinner,
    } = useLotteryDraw({
        maxMaleWinners: maleQuota,
        maxFemaleWinners: femaleQuota,
        meritWinners: phase?.meritWinners,
    });

    // Refreshing mid-spin replaces the pool, which resets the reel and aborts the
    // draw in front of the audience. The page owns this because it is the only
    // place that sees both the reel and the winners panel.
    const [isSpinning, setIsSpinning] = useState(false);

    if (loading) return <DrawLoadingScreen/>;

    return (
        <div
            className="hp-draw min-h-screen flex flex-col overflow-hidden bg-cover bg-center bg-no-repeat"
            style={{backgroundImage: "url('/happy_pay_2026/3840x2160.jpg')"}}
        >
            <div className="flex-1 flex gap-[clamp(0.75rem,1.5vw,1.5rem)] p-[clamp(0.75rem,1.5vw,1.5rem)] overflow-hidden">
                <div className="w-[clamp(240px,21vw,360px)] flex-shrink-0">
                    <WinnersPanel
                        winners={winners}
                        maxWinners={maxWinners}
                        refreshing={refreshing}
                        refreshDisabled={isSpinning}
                        onRefresh={refresh}
                        onShowResults={openFinalModal}
                    />
                </div>

                <div className="flex-1 overflow-hidden">
                    <RandomLotteryComponent
                        name={heading}
                        allLotteries={allLotteries}
                        winnableLotteries={currentTrack}
                        meritWinner={meritWinner}
                        lotteriesWon={winners.length}
                        maxLotteries={maxWinners}
                        onWinnerSelected={selectWinner}
                        onSpinningChange={setIsSpinning}
                        spinDuration={CAMPAIGN.draw.spinDurationSeconds}
                        scrollSpeed={CAMPAIGN.draw.marqueeScrollSeconds}
                        isComplete={isComplete}
                    />
                </div>
            </div>

            <WinnerModal
                open={isWinnerModalOpen}
                winner={currentWinner}
                winnerIndex={winners.length + 1}
                maxWinners={maxWinners}
                isSaving={isSaving}
                onConfirm={confirmWinner}
            />

            <FinalResultsModal
                open={isFinalModalOpen}
                winners={winners}
                onClose={closeFinalModal}
            />
        </div>
    );
};

HappyPayLottery.propTypes = {
    maxMaleWinners: PropTypes.number,
    maxFemaleWinners: PropTypes.number,
    name: PropTypes.string,
};

export default HappyPayLottery;
